// action - state management
import { AUTH_ACTIONS } from 'config';

// initial state
export const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  loginStatus: null,
  permission: [],
  decodedToken: null,
  currentUser: {},
  orgs: [],
  roles: [],
  currentOrg: {},
  apps: [],
  currentApp: {},
  loading: false,
  serviceToken: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_ACTIONS.REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case AUTH_ACTIONS.LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user
      };
    }
    case AUTH_ACTIONS.LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null
      };
    }
    case AUTH_ACTIONS.UPDATE_STATUS: {
      const { loginStatus } = action.payload;
      return {
        ...state,
        loginStatus
      };
    }
    case AUTH_ACTIONS.UPDATE_PERMISSION: {
      const { permission } = action.payload;
      return {
        ...state,
        permission
      };
    }
    case AUTH_ACTIONS.SET_CURRENT_USER: {
      const { currentUser } = action.payload;
      return {
        ...state,
        currentUser: currentUser
      };
    }
    case AUTH_ACTIONS.SET_PERMISSION: {
      const { permission } = action.payload;
      return {
        ...state,
        permission
      };
    }
    case AUTH_ACTIONS.SET_ORGS:
      return {
        ...state,
        orgs: action.payload
      };
    case AUTH_ACTIONS.UPDATE_AUTH:
      return {
        ...state,
        ...action.payload
      };
    case AUTH_ACTIONS.UPDATE_DATABASE: {
      const { dbname } = action.payload;
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          db_name: dbname
        }
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
